export default [{
    path: 'positionGrade',
    component: () => import('@/views/organization/positionGrade/position.grade.main'),
    children: [
        {
            name: 'positionGradeList',
            path: 'list',
            components: {
                list: () => import('@/views/organization/positionGrade/position.grade.list'),
            },
        },
        {
            name: 'positionGradeDetail',
            path: 'detail',
            components: {
                detail: () => import('@/views/organization/positionGrade/position.grade.detail'),
            },
        }
    ]
}]